import { createActivityRegistry } from './index';

const registry = createActivityRegistry();

Object.assign(globalThis, {
  PiandojoActivities: Object.freeze({
    register: registry.register,
    get: registry.get,
    list: registry.list,
    transition: registry.transition,
    notesChanged: registry.notesChanged,
  }),
});
